// extracted by mini-css-extract-plugin
export default {"Box":"ViolationsList-module__Box--z__7Q"};